import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaEnvelopeOpenText } from "react-icons/fa";

const SiteInquiry = () => {

  const [contact, setContact] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch Contact Data
  const fetchContact = async () => {

    try {

      const response = await axios.get(
        "https://api.statixtrading.in/api/contact"
      );

      if (response.data.success) {

        setContact(response.data.data);

      } else {

        setContact([]);

      }

    } catch (error) {

      console.log("ERROR:", error);

    } finally {

      setLoading(false);

    }

  };

  useEffect(() => {

    fetchContact();

  }, []);

  return (
    <div style={styles.container}>

      <h2 style={styles.heading}>
        
        Site Inquiry
      </h2>

      <div style={styles.card}>

        <table style={styles.table}>

          <thead>

            <tr>

              <th style={styles.th}>SN</th>

              <th style={styles.th}>Name</th>

              <th style={styles.th}>Email</th>

              <th style={styles.th}>Message</th>

              <th style={styles.th}>Date</th>

            </tr>

          </thead>

          <tbody>

            {loading ? (

              <tr>

                <td
                  colSpan="5"
                  style={styles.noData}
                >
                  Loading...
                </td>

              </tr>

            ) : contact.length === 0 ? (

              <tr>

                <td
                  colSpan="5"
                  style={styles.noData}
                >
                  No Inquiry Found
                </td>

              </tr>

            ) : (

              contact.map((item,index) => (

                <tr
                  key={item.id}
                  style={styles.row}
                >

                  <td style={styles.td}>
                    {index+1}
                  </td>

                  <td style={styles.td}>
                    {item.name}
                  </td>

                  <td style={styles.td}>
                    {item.email}
                  </td>

                  <td style={styles.td}>
                    {item.message}
                  </td>

                  <td style={styles.td}>
                    {new Date(
                      item.created_at
                    ).toLocaleString()}
                  </td>

                </tr>

              ))

            )}

          </tbody>

        </table>

      </div>

    </div>
  );
};

const styles = {

  container: {
    padding: "20px",
    background: "#f4f6f9",
    minHeight: "100vh",
  },

  heading: {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "10px",
  marginBottom: "20px",
  color: "#1e293b",
  fontWeight: "700",
  fontSize: "30px",
},
  card: {
    background: "#ffffff",
    padding: "20px",
    borderRadius: "14px",
    overflowX: "auto",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "900px",
  },

  th: {
 background: "#a8aeb6",
    color: "#fff",
    padding: "14px",
    textAlign: "center",
    fontWeight: "700",
    borderBottom: "2px solid #cbd5e1",
    
  },

  td: {
    padding: "14px",
    textAlign: "center",
    borderBottom: "1px solid #e2e8f0",
    color: "#334155",
    background: "#ffffff",
  },

  row: {
    transition: "0.3s",
  },

  noData: {
    textAlign: "center",
    padding: "20px",
    color: "#64748b",
    fontSize: "18px",
  },

};

export default SiteInquiry;